module.exports = __webpack_public_path__ + "img/not-authorized.8b6d8eb7.png";